import { footerGroups, stats } from "@/mocks/community";

export default function Footer() {
  return (
    <footer className="bg-secondary-100 pt-12">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-2 gap-6 border-b border-secondary-200 pb-8 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label}>
              <p className="font-heading text-2xl text-primary-600 md:text-3xl">{item.value}</p>
              <p className="mt-1 text-xs text-secondary-900 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>

        <div className="grid gap-8 py-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#top" className="flex cursor-pointer items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-2xl text-background-50">
                <i className="ri-play-circle-fill"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">久久视频</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-900">
              久久视频聚合免费电影、电视剧、高清影视与最新大片资源，覆盖热门网剧、综艺等多类内容，在在线播放列表里即可快速找到想看的影视资源。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {["免费电影", "电视剧", "高清影视", "最新大片"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-background-50 px-3 py-1 text-xs text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="mb-3 text-sm font-medium text-foreground-950">{group.title}</h3>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-secondary-900 transition-colors hover:text-primary-700"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-2 border-t border-secondary-200 py-6 text-xs text-secondary-900 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 久久视频 · 免费影视资源聚合站，内容仅供学习与交流使用。</p>
          <p className="flex flex-wrap gap-4">
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              站点介绍
            </a>
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              免责声明
            </a>
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              意见反馈
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}